import { 
    AGREGAR_CONSUMO, 
    OBTENER_CONSUMOSPYT,
    ELIMINAR_CONSUMO,
    OBTENER_CONSUMO_ED,
    EDITAR_CONSUMO
} from "../../types";



/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default (state, action) => {
    switch (action.type) {
        
        case OBTENER_CONSUMOSPYT:
            return{
                ...state,
                consumosproyecto: action.payload
            }
        case AGREGAR_CONSUMO:
            return{
                ...state,
                consumosproyecto: [...state.consumosproyecto, action.payload]
            }
        case ELIMINAR_CONSUMO:
            return{
                ...state,
                consumosproyecto: state.consumosproyecto.filter(consumo => consumo._id !== action.payload)
            }
        case OBTENER_CONSUMO_ED:
            return{
                ...state,
                consumoeditar: action.payload
            }
        case EDITAR_CONSUMO:
            return{
                ...state,                
                consumosproyecto: state.consumosproyecto.map(consumo => consumo._id === action.payload._id ? action.payload : consumo)
            }
        default:
            break;
    }
}